"use client";;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();

import { useTranslations } from "next-intl";
import { useState } from "react";
import Icon from "@/components/Icon";
import { useRouter } from "@/i18n/routing";
import "@/components/Button/button.scss";

export default function NotFoundSearch() {
	const t = useTranslations("Header");
	const router = useRouter();
	const [query, setQuery] = useState("");

	const onSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		const trimmed = query.trim();
		if (!trimmed) return;
		router.push(`/search?query=${encodeURIComponent(trimmed)}`);
	};

	return (
		<form className="not-found__search" onSubmit={onSubmit}>
			<label className="sr-only" htmlFor="not-found-search">
				{t("search.placeholder")}
			</label>
			<input
				id="not-found-search"
				className="not-found__search-input"
				type="search"
				name="query"
				value={query}
				onChange={(e) => setQuery(e.target.value)}
				placeholder={t("search.placeholder")}
			/>
			<button type="submit" className="button -primary not-found__search-submit">
				<span className="content">
					<Icon name="search" />
					<span>{t("search.submit")}</span>
				</span>
			</button>
		</form>
	);
}
